/**
 * Map a Papa-parsed shopping-list CSV row (human headers from Download CSV)
 * onto the payload shape expected by admin/venueProducts-csv.
 *
 * Critical: the export header is "Favourite", not "isFavourite". Reading the
 * wrong key previously coerced every row to isFavourite:false and wiped
 * favourites on re-upload.
 */

export const parseFavouriteFlag = raw => {
  if (raw === undefined || raw === null) return undefined
  if (typeof raw === 'boolean') return raw

  const normalised = String(raw).trim().toLowerCase()
  if (!normalised) return undefined
  if (['true', 'yes', '1', 'y'].includes(normalised)) return true
  if (['false', 'no', '0', 'n'].includes(normalised)) return false
  return undefined
}

const firstDefined = (...values) => {
  for (const value of values) {
    if (value !== undefined && value !== null) return value
  }
  return undefined
}

export const formatFavouriteForCsv = isFavourite =>
  isFavourite ? 'TRUE' : 'FALSE'

export const mapShoppingListCsvRow = item => {
  const rawProductId = firstDefined(
    item['Product ID'],
    item.productId,
    item.product,
  )
  const product =
    rawProductId !== undefined && rawProductId !== null
      ? String(rawProductId).trim()
      : undefined

  const rawZone = firstDefined(item.Zone, item.zone)
  const zone =
    rawZone !== undefined && rawZone !== null
      ? String(rawZone).trim()
      : undefined

  const rawDefaultQty = firstDefined(
    item['Default qty'],
    item['Default Qty'],
    item.defaultQuantity,
  )
  const defaultQuantity =
    rawDefaultQty !== undefined &&
    rawDefaultQty !== null &&
    String(rawDefaultQty).trim() !== ''
      ? Number(rawDefaultQty)
      : undefined

  const rawNominalCode = firstDefined(
    item['Nominal Code'],
    item.nominalCode,
    item['Nominal code'],
  )
  const nominalCode =
    rawNominalCode !== undefined && rawNominalCode !== null
      ? String(rawNominalCode).trim()
      : undefined

  const rawFavourite = firstDefined(
    item.Favourite,
    item.Favorite,
    item.favourite,
    item.favorite,
    item.isFavourite,
  )
  const isFavourite = parseFavouriteFlag(rawFavourite)

  const mapped = {
    ...item,
    product,
    zone,
    defaultQuantity,
    nominalCode,
  }

  // Only set isFavourite when the CSV actually provided a favourite value.
  // Omitting it preserves existing favourites on partial re-uploads.
  if (isFavourite !== undefined) {
    mapped.isFavourite = isFavourite
  } else {
    delete mapped.isFavourite
  }

  return mapped
}
